import ZkLoginLog from './src/main'
ZkLoginLog.install = function (Vue) {
  Vue.component(ZkLoginLog.name, ZkLoginLog)
}
export default ZkLoginLog



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/loginLog/index.js